import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as DashboardLayout } from 'src/layouts/dashboard';

const QuestionListPage = lazy(() => import('src/pages/questionBank/question/questionList'));
 const QuestionCreatePage = lazy(() => import('src/pages/questionBank/question/createQuestion'));

export const questionBankRoutes = [
  {
    path: 'questionBank',
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        path: 'question',
        children: [
          {
            index: true,
            element: <QuestionListPage />
          },
          {
            path: 'createQuestion',
            element: <QuestionCreatePage />
          }
        ]
      },
  
    ]
  }
];
